module.exports = __webpack_public_path__ + "media/metal_4.d049aff5.webm";